module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1900.f9d5f462.svg";